export default __webpack_public_path__ + "static/media/residue_practice_fodder.044ff0d3.jpg";